<div class="container-fluid">
  <div class="row">
    <div class="col-xl-5 p-0">
      <!-- <div class="h-100 w-100 rounded-5" [ngStyle]="{'background-image': 'url(./../../../../assets/svg/login-bg.svg)',
                                            'background-size': 'cover',
                                            'background-position': 'center center',
                                            'display': 'block'}">
        <div class="h-75 d-flex align-items-center justify-content-center">
          <img class="w-225px h-225px" src="./../../../assets/svg/login/chatbot.svg" alt="looginpage">
        </div>
        <div class="h-25">
        </div>
      </div> -->

      <div class="chatbot-landing h-100 rounded-0">
        <img src="./../../../../assets/svg/login-bg.svg" alt="Background" class="background">
    
        <img src="./../../../assets/svg/login/blue-chat.svg" alt="Chat Bubble" class="chat-bubble">
        <img src="./../../../assets/svg/login/chatbot.svg" alt="Robot" class="robot">
        <img src="./../../../assets/svg/login/rays.svg" alt="Robot" class="robot h-500px w-500px z-0">
        <img src="./../../../assets/svg/login/pink-chat.svg" alt="Chat Pink" class="pink-chat">

        <!-- Bubbles -->
        <img src="./../../../assets/svg/login/bubble-one.svg" alt="Bubble" class="bubble bubble-1">
        <img src="./../../../assets/svg/login/bubble-two.svg" alt="Bubble" class="bubble bubble-2">
        <img src="./../../../assets/svg/login/bubble-three.svg" alt="Bubble" class="bubble bubble-3">
        <img src="./../../../assets/svg/login/bubble-four.svg" alt="Bubble" class="bubble bubble-4">

        <!-- Hearts -->
        <img src="./../../../assets/svg/login/heart-one.svg" alt="Bubble" class="heart heart-1">
        <img src="./../../../assets/svg/login/heart-two.svg" alt="Bubble" class="heart heart-2">
        <img src="./../../../assets/svg/login/heart-three.svg" alt="Bubble" class="heart heart-3">
        <img src="./../../../assets/svg/login/heart-four.svg" alt="Bubble" class="heart heart-4">
        <img src="./../../../assets/svg/login/heart-five.svg" alt="Bubble" class="heart heart-5">
    
        <!-- User Icons -->
        <img src="./../../../assets/svg/login/image-one.svg" alt="User 1" class="user user-1">
        <img src="./../../../assets/svg/login/image-two.svg" alt="User 2" class="user user-2">
        <img src="./../../../assets/svg/login/image-three.svg" alt="User 3" class="user user-3">
        <img src="./../../../assets/svg/login/image-four.svg" alt="User 4" class="user user-4">
    
        <!-- Text Content -->
        <div class="text-content">
          <h1>I'm Here For You, Let's Talk.</h1>
          <p>"ChatbotHub is your virtual assistant for quick help and support — just send a message, and we're here to assist instantly!"</p>
        </div>
      </div>
    </div>
    <div class="col-xl-7 p-0">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo text-start" href="#">
              <img class="img-fluid for-light h-75px bounce " src="./../../../assets/svg/login/bot_logo.svg" alt="looginpage">
              <!-- <img class="img-fluid for-dark" src="./../../../assets/images/logo/logo_dark.png" alt="looginpage"> -->
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="signInForm">
              <h4>Get Started Now</h4>
              <p>Enter your credentials to access your account.</p>

              <div class="invalid-border p-2 rounded-2 mb-4 error-div fadeUp" *ngIf="emailHasError || passwordHasError">
                Invalid Email/Password
              </div>

              <div class="form-group mb-0">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" required="" placeholder="app@yourmail.com"
                  formControlName="email" (keyup)="emailHasError = false"
                  [ngClass]="{'invalid-border' : (signInForm.get('email')?.hasError('required') || signInForm.get('email')?.hasError('email') || emailHasError) && signInForm.get('email')?.touched}">
              </div>
              <div *ngIf="signInForm.get('email')?.touched" class=" w-100 text-start">
                <small class="text-danger fs-13px" *ngIf="signInForm.get('email')?.hasError('required')">Email is
                  required.</small>
                <small class="text-danger fs-13px" *ngIf="signInForm.get('email')?.hasError('email')">Invalid email
                  format.</small>
              </div>

              <div class="form-group mb-0 mt-2">
                <label class="col-form-label">Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]" required=""
                  formControlName="password" placeholder="*********"  (keyup)="passwordHasError = false"
                  [ngClass]="{'invalid-border' : (signInForm.get('password')?.hasError('required') || signInForm.get('password')?.hasError('minlength') || passwordHasError) && signInForm.get('password')?.touched}">
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div *ngIf="signInForm.get('password')?.touched" class="w-100 text-start">
                <small class="text-danger fs-13px" *ngIf="signInForm.get('password')?.hasError('required')">Password is
                  required.</small>
                <small class="text-danger fs-13px" *ngIf="signInForm.get('password')?.hasError('minlength')">Password
                  must be at
                  least 6 characters.</small>
              </div>
              <div class="form-group mb-0">
                <!-- <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox">
                  <label class="text-muted" for="checkbox1">Remember password</label>
                </div>
                <a class="link">Forgot password?</a> -->
                <button class="btn btn-primary d-block w-100 mt-12" type="submit" [disabled]="loginApiLoading"
                  (click)="login()">
                  <ng-container *ngIf="!loginApiLoading; else loading">
                    Sign in
                  </ng-container>

                  <ng-template #loading>
                    <div class="d-flex align-items-center justify-content-center fadeUp">
                      <div class="loader-box h-auto">
                        <div class="loader-2 h-25px w-25px"></div>
                      </div>
                      <span class="ms-2" style="color: #ffffff !important;">Signing in...</span>
                    </div>
                  </ng-template>
                </button>

              </div>
              <!-- <h6 class="text-muted mt-4 or">Or Sign in with</h6> -->
              <!-- <div class="social mt-4"> -->
              <!-- <div class="btn-showcase">
                  <a class="btn btn-light" href="https://www.linkedin.com/login" target="_blank">
                    <app-feather-icons [icon]="'linkedin'" class="txt-linkedin"></app-feather-icons> LinkedIn 
                  </a>
                  <a class="btn btn-light" href="https://twitter.com/login?lang=en" target="_blank">
                   <app-feather-icons [icon]="'twitter'" class="txt-twitter"></app-feather-icons>twitter
                  </a>
                  <a class="btn btn-light" href="https://www.facebook.com/" target="_blank">
                    <app-feather-icons [icon]="'facebook'" class="txt-fb"></app-feather-icons>facebook
                  </a>
                </div> -->
              <!-- </div> -->
              <!-- <p class="mt-4 mb-0">Don't have account?
                <a [routerLink]="'/authentication/register/simple'" class="ms-2">Create Account</a>
              </p> -->
            </form>
            <span class="position-absolute bottom-0 mb-7 f-w-400 fs-14px">Copyright © 2025 <a class="text-primary f-w-500 ">Mobile Sentrix</a>. All Rights Reserved.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>